// extracted by mini-css-extract-plugin
export default {"two_column":"two_column_page_two_column__vF2OZ","banner":"two_column_page_banner__Z2qOZ","content":"two_column_page_content__audJW"};